/** Ana iş parçacığına nefes verir (UI donmasını önler). */
export const yieldToMain = () => new Promise((resolve) => setTimeout(resolve, 0));
/** Modal paint sonrası ağır işleri ertelemek için çift rAF. */
export const deferAfterPaint = () => new Promise((resolve) => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => resolve());
    });
});
/** Dizi dönüşümünü parçalar halinde yapar; her parçadan sonra yield. */
export async function mapInChunks(items, mapper, chunkSize = 50) {
    if (!items.length)
        return [];
    const out = [];
    for (let i = 0; i < items.length; i += chunkSize) {
        const end = Math.min(i + chunkSize, items.length);
        for (let j = i; j < end; j++) {
            out.push(mapper(items[j], j));
        }
        if (end < items.length) {
            await yieldToMain();
        }
    }
    return out;
}
